export default __webpack_public_path__ + "static/media/br_rg_front.7bbc3d99.jpeg";